const image_path = '/assets/img/';

export const initZoomModal = () => {
  const thumbnails = document.querySelectorAll('.zoom-icon');
  const zoomModals = document.querySelectorAll('.zoom');
  const header = document.querySelector('.header');

  // 画像クリックでモーダルを開く
  thumbnails.forEach((thumbnail) => {
    const id = thumbnail.getAttribute('data-id');

    thumbnail.addEventListener('click', () => {
      const correspondingZoom = document.querySelector(`.zoom[data-id="${id}"]`);

      if (correspondingZoom) {
        correspondingZoom.classList.add('-active');
        document.body.style.overflow = 'hidden';
        if (header) header.classList.add('hidden');

        // PinchOut 要素を追加する処理
        const pinchOutFigure = document.createElement('figure');
        pinchOutFigure.className = 'PinchOut sp';

        const pinchOutImg = document.createElement('img');
        pinchOutImg.src = image_path + "PinchOut.svg";
        pinchOutFigure.appendChild(pinchOutImg);

        pinchOutFigure.style.opacity = 0;
        pinchOutFigure.style.transition = "opacity 0.5s";

        correspondingZoom.appendChild(pinchOutFigure);

        requestAnimationFrame(() => {
          pinchOutFigure.style.opacity = 1;
        });

        setTimeout(() => {
          pinchOutFigure.style.opacity = 0;
          pinchOutFigure.addEventListener('transitionend', () => {
            if (pinchOutFigure.parentNode) {
              pinchOutFigure.parentNode.removeChild(pinchOutFigure);
            }
          }, { once: true });
        }, 2000);
      } else {
        console.error("No corresponding modal found for data-id:", id);
      }
    });
  });

  // モーダルを閉じる処理 (×ボタン)
  const closeButtons = document.querySelectorAll('.zoom .close');
  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      const correspondingZoom = closeButton.closest('.zoom');

      if (correspondingZoom) {
        correspondingZoom.classList.remove('-active');
        document.body.style.overflow = 'auto';
        if (header) header.classList.remove('hidden');
      }
    });
  });

  // モーダル外をクリックして閉じる処理
  document.addEventListener('click', (event) => {
    zoomModals.forEach((zoom) => {
      if (zoom.classList.contains('-active')) {
        if (!zoom.contains(event.target) && !event.target.closest('figure.thumb')) {
          zoom.classList.remove('-active');
          document.body.style.overflow = 'auto';
          if (header) header.classList.remove('hidden');
        }
      }
    });
  });
};
